export const enum AppRoutes {
  Home = '/',
  Prequalification = '/prequalification',
  AcknowledgementAndConsent = '/acknowledgement-and-consent',
  Login = '/login',
  Dashboard = '/dashboard',
  ResetPassword = '/reset-password',
  IdentityVerification = '/identity-verification',
  CompleteAuthentication = '/complete-auth',
  CompleteMobileAuthentication = '/complete-mobile-auth',
  ContractorPortal = '/contractor-portal',
  LegacyContractorPortal = '/contractor-portal/legacy',
  LoanPortal = '/loan-portal',
  OfferProcessing = '/offer-processing',
  ResumeProcess = '/resume-process',
  Other = '*',
  Error = '/error',
  NotQualified = '/not-qualified',
  PasswordProtection = '/password-protection',
  ValidationSession = '/validation-session',
  MasterDealerAgreement = '/master-dealer-agreement',
}
